"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateHospitalSchema = exports.createHospitalSchema = exports.hospitalShape = void 0;
const zod_1 = require("zod");
exports.hospitalShape = {
    legalName: zod_1.z.string().min(1).max(255),
    displayName: zod_1.z.string().min(1).max(255),
    registrationNumber: zod_1.z.string().max(100).optional(),
    gstNumber: zod_1.z.string().max(20).optional(),
    panNumber: zod_1.z.string().max(20).optional(),
    // Pharmacy Invoice Print — displayed alongside GSTIN on a pharmacy tax invoice.
    drugLicenseNumber: zod_1.z.string().max(50).optional(),
    nabhAccredited: zod_1.z.boolean().default(false),
    nabhAccreditationNumber: zod_1.z.string().max(100).optional(),
    jciAccredited: zod_1.z.boolean().default(false),
    jciAccreditationNumber: zod_1.z.string().max(100).optional(),
    logoStorageKey: zod_1.z.string().max(500).optional(),
    contactEmail: zod_1.z.string().email().optional(),
    contactPhone: zod_1.z.string().max(20).optional(),
    addressLine1: zod_1.z.string().max(255).optional(),
    addressLine2: zod_1.z.string().max(255).optional(),
    city: zod_1.z.string().max(100).optional(),
    state: zod_1.z.string().max(100).optional(),
    country: zod_1.z.string().max(100).default('India'),
    postalCode: zod_1.z.string().max(20).optional(),
};
exports.createHospitalSchema = zod_1.z.object(exports.hospitalShape);
exports.updateHospitalSchema = exports.createHospitalSchema.partial();
//# sourceMappingURL=hospital.schema.js.map